<template>
    <div class="com-part1">
        <MyTitle title="高负载服务器" subTitle="Server load TOP5" />
        <div class="sub-title flex justify-end align-center">
            <div
                v-for="(item, i) in subTitle" :key="'subTitle' + i"
                @click="subTitleChange(i)">
                <p :class="{'at': i == subTitleAt}">{{ item.label }}</p>
            </div>
        </div>
        <div class="p-content">
			<div
				v-for="(item, i) in loadList"
				:key="'loadList' + i"
				class="load-list">
				<div class="flex item-t">
					<div class="icon-bg flex justify-center align-center">{{ i + 1 }}</div>
					<div>{{ item.ip }}</div>
				</div>
				<div class="flex item-b  align-center">
					<div class="flex1 item-l">
						<div class="solid" :style="{'width': `${item.num}%`}"></div>
					</div>
					<div class="flexs flex justify-center item-r">{{ item.num }}% </div>
				</div>
			</div>
        </div>
    </div>
</template>

<script>
import MyTitle from '../myTitle.vue'
// import myEchart from "./charts/echarts"
import { dataInterface } from "@/api/dataInterfaceApi"
import { formatTime } from '@/utils/index'
export default {
    components: {
        MyTitle,
        // myEchart
    },
    data() {
        return {
            subTitle: [
                {
                    label: 'GPU'
                },
                {
                    label: 'CPU'
                },
                {
                    label: '内存'
                },
                {
                    label: '存储'
                }
            ],
            subTitleAt: 0,
			loadList: [
				{
					ip: '123123123123',
					num: 80
				},
				{
					ip: '123123123',
					num: 80
				},
				{
					ip: '2131231',
					num: 80
				},
				{
					ip: '123123',
					num: 80
				},
				{
					ip: '123123123',
					num: 40
				}
			]
        }
    },
	mounted() {
    },
	methods: {
        // 副标题切换
        subTitleChange(i) {
            this.subTitleAt = i
        },
    }
}
</script>

<style lang="scss" scoped>
@import '../comm.scss';
.com-part1 {
    width: 100%;
    height: 843px;
    .sub-title {
        font-size: $FontSize20;
        padding-top: 20px;
        height: 50px;
        > div {
            padding-right: 20px;
            > p {
                text-shadow: 0px 0px 9px #03B9BD;
                padding: 0 10px;
                position: relative;
                cursor: pointer;
                &.at {
                    &::after {
                        position: absolute;
                        bottom: -10px;
                        left: 0;
                        content: '';
                        width: 100%;
                        height: 2px;
                        background: linear-gradient(270deg, rgba(113, 186, 188, 0.0001) 0%, #71BBBD 33.33%, #6DB5B7 66.67%, rgba(111, 185, 187, 0.0001) 100%);
                    }
                }
            }
        }
    }

    .p-content {
        width: 100%;
        height: 843px;
		padding: 0 10px;
		box-sizing: border-box;
		.load-list {
			font-size: $FontSize24;
			margin: 40px 0;
			.item-t {
				.icon-bg {
					width: 36px;
					height: 42px;
					background: url(~@/assets/images/computility/dispatch-icon6.png) center no-repeat;
					background-size: 100%;
					padding-bottom: 6px;
					box-sizing: border-box;
					font-size: $FontSize20;
					margin-right: 20px;
				}
			}
			.item-b {
				height: 50px;
				.item-l {
					height: 13px;
					background-color: rgba(208, 222, 238, 0.1);
					.solid {
						background: linear-gradient(270deg, #1FFAFF 1.64%, #E2FFFD 100%);
						position: relative;
						height: 13px;
						&::before {
							position: absolute;
							content: '';
							background-color: #fff;
							box-shadow: 0px 0px 4px 0px #EFD48E;
							width: 18px;
							height: 18px;
							right: -9px;
							top: -3px;
							border-radius: 50%;
						}
					}
				}
				.item-r {
					width: 80px;
				}
			}
		}
    }
}
</style>